<template>
  <main>
    <PageSections :sections="sections"/>
  </main>
</template>

<script lang="ts">
import {ViewDataMixin} from '@/views/mixins'
import {PageSections} from '@/components/sections'
import {usePageStore} from '@/stores'

export default {
  name: 'NotFound',
  mixins: [ViewDataMixin],
  components: {PageSections},
  data() {
    return {
      page: null as Page | null
    }
  },
  computed: {
    sections() {
      return this.page?.data?.sections ?? [{
        background: 'white' as background,
        buttons: [{
          link: `${window.location.origin}/`,
          label: this.$t('not_found.button')
        }],
        description: this.$t('not_found.description'),
        title: this.$t('not_found.title'),
        flexKey: 'text-image-section',
        flexLayout: 'text-image-section' as sectionType
      }] as RepeatableSection []
    }
  },
  methods: {
    async init() {
      const page = await usePageStore().get('not_found')

      if (!page) {
        return await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.page = page
    }
  }
}
</script>